export default function (config) {
	config.baseURL = process.env.VUE_APP_API_ROOT;

	if (localStorage.authKey || sessionStorage.authKey) {
		config.headers.Authorization = `Bearer ${localStorage.authKey || sessionStorage.authKey}`;
	}
}
